<template>
  <div class="page">
    <h2 v-if="createMode">Создание сотрудника</h2>
    <h2 v-else>Редактирования сотрудника</h2>
    <card class="vm-card">
      <form v-on:submit.prevent="onSubmit">
        <div class="vm-form-group">
          <div class="vm-label">
            Фамилия
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                :state="!$v.form.lastName.$error ? null : false"
                v-model="form.lastName"
                @blur="$v.form.lastName.$touch()"
                placeholder="Введите фамилию..."
              ></b-form-input>
              <error
                v-if="$v.form.lastName.$error && !$v.form.lastName.required"
              >
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label">
            Имя
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                :state="!$v.form.firstName.$error ? null : false"
                v-model="form.firstName"
                @blur="$v.form.firstName.$touch()"
                placeholder="Введите имя..."
              ></b-form-input>
              <error
                v-if="$v.form.firstName.$error && !$v.form.firstName.required"
              >
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label">
            Отчество
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                v-model="form.middleName"
                placeholder="Введите отчество..."
              ></b-form-input>
            </form-field>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label">
            Email
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                :state="!$v.form.email.$error ? null : false"
                v-model="form.email"
                @blur="$v.form.email.$touch()"
                placeholder="Введите email..."
              ></b-form-input>
              <error v-if="$v.form.email.$error && !$v.form.email.required">
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label">
            Телефон
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                :state="!$v.form.phone.$error ? null : false"
                v-model="form.phone"
                @blur="$v.form.phone.$touch()"
                placeholder="Введите телефон..."
              ></b-form-input>
              <error v-if="$v.form.phone.$error && !$v.form.phone.required">
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label">
            Рабочий email
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                :state="!$v.form.workemail.$error ? null : false"
                @blur="$v.form.workemail.$touch()"
                v-model="form.workemail"
                placeholder="Введите email..."
              ></b-form-input>
              <error
                v-if="$v.form.workemail.$error && !$v.form.workemail.required"
              >
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>
        <div class="vm-form-group">
          <div class="vm-label">
            Рабочий телефон
          </div>
          <div class="vm-input-field">
            <form-field>
              <b-form-input
                :state="!$v.form.workphone.$error ? null : false"
                @blur="$v.form.workphone.$touch()"
                v-model="form.workphone"
                placeholder="Введите телефон..."
              ></b-form-input>
              <error
                v-if="$v.form.workphone.$error && !$v.form.workphone.required"
              >
                Это поле обязательное
              </error>
            </form-field>
          </div>
        </div>

        <div class="form-group form-group-actions">
          <button
            v-on:click="toList()"
            type="button"
            class="btn btn-outline-primary"
          >
            Отменить
          </button>
          <button type="submit" class="btn btn-primary">
            {{ createMode ? 'Создать' : 'Сохранить' }}
          </button>
        </div>
      </form>
    </card>
  </div>
</template>

<script>
import { employeeApi as api } from '../../services';
import { required } from 'vuelidate/lib/validators';
import Card from '@app/components/uikit/Card';
import FormField from '@app/components/uikit/FormField';
import Error from '@app/components/uikit/Error';

export default {
  components: { Card, FormField, Error },
  data: () => ({
    createMode: false,
    form: {
      firstName: null,
      middleName: null,
      lastName: null,
      email: null,
      phone: null,
      workemail: null,
      workphone: null
    }
  }),
  validations: {
    form: {
      firstName: { required },
      lastName: { required },
      email: { required },
      phone: { required },
      workemail: { required },
      workphone: { required }
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      try {
        if (this.createMode) {
          await api.create(this.form);
        } else {
          const uuid = this.$route.params.uuid;
          await api.update(uuid, this.form);
        }
        this.toList();
      } catch (err) {
        console.error(err);
      }
    },
    toList() {
      this.$router.push({ name: 'registry.employees' });
    },
    async fetchData() {
      const uuid =
        typeof this.$route.params.uuid === 'undefined'
          ? null
          : this.$route.params.uuid;
      if (uuid === null) {
        this.createMode = true;
        return;
      }
      const loading = this.$loading.show();
      const data = await api.get(uuid);
      delete data.id;
      this.form = data;
      loading.hide();
    }
  }
};
</script>

<style scoped>
form {
  display: flex;
  flex-direction: column;
}
.vm-form-group {
  display: flex;
  justify-content: center;
}
.vm-label {
  color: #a4a8b0;
  width: 20%;
  margin-top: 0.5rem;
}
.vm-input-field {
  width: 80%;
}
@media (max-width: 700px) {
  .vm-form-group {
    flex-direction: column;
  }
  .vm-label {
    width: 100%;
    margin-bottom: 0.5rem;
  }
  .vm-input-field {
    width: 100%;
  }
}

h2 {
  font-size: 1.5rem;
  color: #727272;
  margin-bottom: 2rem;
}
.form-group-actions {
  margin: 0;
  display: flex;
  justify-content: flex-end;
}
.form-group-actions .btn:first-child {
  margin-right: 6px;
}
.vm-card {
  padding: 2rem;
}
::v-deep .form-group label {
  color: #a3aab2;
}
</style>
